import React, { useContext } from "react";
import PropTypes from "prop-types";
import { ThemeContext } from "helpers/contexts.js";
import LinearProgress from "@material-ui/core/LinearProgress";
import { lighten, withStyles } from "@material-ui/core/styles";
import { GLOBAL_LOADER_VARIANT } from "constant";

GlobalLoader.propTypes = {
  isLoading: PropTypes.bool,
  variant: PropTypes.oneOf(Object.values(GLOBAL_LOADER_VARIANT)),
  value: PropTypes.number,
};

GlobalLoader.defaultProps = {
  isLoading: false,
  variant: GLOBAL_LOADER_VARIANT.indeterminate,
  value: 0,
};

function GlobalLoader(props) {
  const theme = useContext(ThemeContext);
  const progressBarColor = theme.colors.black;
  const BorderLinearProgress = withStyles({
    root: {
      height: GLOBAL_HEADER_HIGHT,
      backgroundColor: lighten(progressBarColor, GLOBAL_HEADER_OPACITY),
    },
    bar: {
      backgroundColor: progressBarColor,
      animationDuration: "2.5s",
    },
  })(LinearProgress);

  return (
    props.isLoading && (
      <BorderLinearProgress variant={props.variant} value={props.value} />
    )
  );
}

const GLOBAL_HEADER_HIGHT = 4;
const GLOBAL_HEADER_OPACITY = 0.7;

export default React.memo(GlobalLoader);
